import React from 'react';

import { Input, FormGroup, Label, FormFeedback, FormText } from 'reactstrap';

function TextFieldGroup(props) {
    const { field, value, label, error, type, onChange, description, className, disabled } = props;

    return (
        <FormGroup className={className}>
            <Label for={field}>{label}</Label>
            <Input
                disabled={disabled}
                type={type}
                name={field}
                value={value || ""}
                onChange={onChange}
                invalid={error ? true : false}   
            />
            {error && <FormFeedback>{error}</FormFeedback>}
            {description && <FormText>{description}</FormText>}
            {props.children}
        </FormGroup>
    );
}

export default TextFieldGroup;
